import { render } from "./DetallesServicios.vue?vue&type=template&id=0225a65a&scoped=true"
import script from "./DetallesServicios.vue?vue&type=script&lang=js"
export * from "./DetallesServicios.vue?vue&type=script&lang=js"

import "./DetallesServicios.vue?vue&type=style&index=0&id=0225a65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225a65a"]])

export default __exports__